function CollectSampleNote({ collectSampleNote, setCollectSampleNote, isCollect, setIsCollect, selectedRecruitedDonor, id }) {
    return (
        <>
            <div className="mt-3">
                <label>Collection Notes</label>
                <input
                    type="text"
                    className="form-control"
                    name="collection-note"
                    onChange={(e) => setCollectSampleNote(e.target.value)}
                    value={collectSampleNote}
                    id="collection-note"
                    placeholder="Type here"
                ></input>

                {    
                    selectedRecruitedDonor &&
                    !selectedRecruitedDonor?.donated_samples
                        ?.split(',')
                        .map((sample) => sample.trim())
                        .includes(id.toString()) && (
                        <div className="mt-2">                            
                            <button
                                onClick={() => setIsCollect(true)}
                                className="el-main-button"
                                type="button"
                            >
                                <span>Collect</span>
                            </button>
                        </div>
                    )
                }

            </div>
        </>);
}

export default CollectSampleNote